import React from 'react';
import { Box } from '@mui/material';
import styles from './styles.module.css';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useCasinoEnabled } from '../../../context/CasinoEnabledContext';
import Aviator from '../../../images/Aviator.png';
import Dragon_tiger from '../../../images/other_game/Dragon_tiger.png';
import andar_bahar from '../../../images/other_game/andar_bahar.png';
import dragon_tiger_today from '../../../images/other_game/dragon_tiger_today.png';
import roulete from '../../../images/other_game/roulete.png';
import three_two_cards from '../../../images/other_game/three_two_cards.png';
import amar_akbar_anthony from '../../../images/other_game/amar_akbar_anthony.png';
import teen_patti320 from '../../../images/other_game/teen_patti320.png';
import bollywood_casino from '../../../images/other_game/bollywood_casino.png';
import lucky7 from '../../../images/other_game/lucky7.png';
import teen_patti_2card from '../../../images/other_game/teen_patti_2card.png';
import dragon_tiger_lion from '../../../images/other_game/dragon_tiger_lion.png';
import baccarat from '../../../images/other_game/baccarat.png';
import instant_game_full from '../../../images/instant_Game_full.png';

const bannerImage = Aviator;

const games = [
    { title: 'Dragon Tiger', image: Dragon_tiger },
    { title: 'Andar Bahar', image: andar_bahar },
    { title: 'Roulete', image: roulete },
    { title: 'One Day Dragon Tiger', image: dragon_tiger_today },
    { title: '32 Cards', image: three_two_cards },
    { title: 'Amar Akbar Anthony', image: amar_akbar_anthony },
    { title: 'Teen Patti T20', image: teen_patti320 },
    { title: 'Bollywood Casino', image: bollywood_casino },
    { title: 'Lucky 7', image: lucky7 },
    { title: '2 Card Teen Patti', image: teen_patti_2card },
    { title: 'Dragon Tiger Lion', image: dragon_tiger_lion },
    { title: 'Baccarat', image: baccarat },
];

const OtherGameGrid = () => {
    const navigate = useNavigate();

    // Same admin Casino ON/OFF value used by Home tabs and route guard
    const { casinoEnabled } = useCasinoEnabled();

    const isAuthenticated = useSelector((state) => state.auth.authenticated);

    // Guests can see the tables but cannot open them: show the login popup instead
    const openGame = (title) => {
        if (!isAuthenticated) {
            window.dispatchEvent(new Event('openLoginModal'));
            return;
        }
        navigate(`/CasinoBetTab?game=${encodeURIComponent(title)}`);
    };

    const handleClick = (game) => openGame(game.title);
    const handleAviatorClick = () => openGame('Aviator');
    const handleInstantGameClick = () => openGame('InstantGame');   // FIXED

    if (!casinoEnabled) return null;

    return (
        <Box sx={{ width: '100%' }}>
            {/* Aviator banner */}
            <Box>
                <Box onClick={handleAviatorClick} sx={{ cursor: 'pointer' }}>
                    <img src={bannerImage} alt="Aviator" className={styles.bannerImage} />
                </Box>
            </Box>

            {/* Instant Game banner */}
            <Box>
                <Box onClick={handleInstantGameClick} sx={{ cursor: 'pointer' }}>
                    <img src={instant_game_full} alt="Instant Game" className={styles.bannerImage} />
                </Box>
            </Box>

            {/* Game grid */}
            <Box className={styles.Grid_container}>
                {games.map((game) => (
                    <Box
                        key={game.title}
                        onClick={() => handleClick(game)}
                        sx={{ cursor: 'pointer' }}
                        className={styles.Grid_container_inner}
                    >
                        <img src={game.image} alt={game.title} className={styles.Grid_image} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default OtherGameGrid;